"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.whitespaceValidator = exports.validOrEmptyDateInputValidator = exports.validDateAndNotEmptyIfHasInitialValueValidator = exports.urlValidator = exports.priceValidator = exports.percentValidator = exports.patternValidator = exports.passwordValidator = exports.npiNumberValidator = exports.imageUploaderImageRequiredValidator = exports.getNicknameValidators = exports.getMaxPriceValidator = exports.getEmailValidators = exports.fieldValidator = exports.eRxIdValidator = exports.dollarsCentsValidator = exports.copayValidator = exports.birthDateValidator = void 0;
var _lodash = require("lodash");
var _validate = _interopRequireDefault(require("validate.js"));
var _pluralize = _interopRequireDefault(require("pluralize"));
var _ = require("./");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * NOTE: debounced validators should not be returned inside the React render cycle
 * as this causes the debounce timer to reset with every render.
 *
 * Either declare the validator outside of the React component or
 * use useMemo to memoize the validator.
 */
var debounceDelay = 700;

// TODO: Can probably deprecate this since we don't want use schedule once labels anymore?
var fieldValidator = function fieldValidator(name) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? debounceDelay : _ref$delay,
    _ref$forbiddenSymbols = _ref.forbiddenSymbolsPattern,
    forbiddenSymbolsPattern = _ref$forbiddenSymbols === void 0 ? _.urlForbiddenSymbolRegex : _ref$forbiddenSymbols,
    skippedValue = _ref.skippedValue;
  return (0, _lodash.debounce)(function (rule, value, callback) {
    if (!value || !value.trim() || skippedValue && skippedValue === value) {
      return callback();
    }
    var invalidChars = (0, _lodash.uniq)([].concat(_toConsumableArray(value.match(forbiddenSymbolsPattern) || []), _toConsumableArray(value.match(_.invalidHttpHeaderCharRegex) || [])));
    if (!(0, _lodash.isEmpty)(invalidChars)) {
      return callback("".concat((0, _lodash.capitalize)(name), " cannot contain the ").concat((0, _pluralize.default)('character', invalidChars.length), " ").concat(invalidChars.join(', ')));
    }
    _.api.get((0, _.getValidatorsUrl)(name, value)).then(function (_ref2) {
      var data = _ref2.data;
      // TODO: remove array [of errors] from here
      var _data$exists = data.exists,
        exists = _data$exists === void 0 ? false : _data$exists;
      var errText;
      switch (name) {
        case 'scheduleoncelabel':
          if (exists) {
            errText = 'Someone already has the same Schedule Once Label. Please try another one.';
          }
          break;
        default:
          break;
      }
      callback(errText);
    }).catch(function (reason) {
      return console.error('Was not able to validate ' + name, reason);
    });
  }, delay);
};

// We don't want to validate email existence for any patient-facing forms
// to prevent hackers from figuring out what emails have been stored in our DB
exports.fieldValidator = fieldValidator;
var getEmailValidators = function getEmailValidators() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$delay = _ref3.delay,
    delay = _ref3$delay === void 0 ? debounceDelay : _ref3$delay,
    _ref3$existenceValida = _ref3.existenceValidation,
    existenceValidation = _ref3$existenceValida === void 0 ? false : _ref3$existenceValida;
  var emailValidator = (0, _lodash.debounce)(function (rule, value, callback) {
    if (!value || !value.trim()) {
      return callback();
    }
    var invalidChars = (0, _lodash.uniq)(_toConsumableArray(value.match(_.invalidHttpHeaderCharRegex) || []));
    if (!(0, _lodash.isEmpty)(invalidChars)) {
      return callback("Email cannot contain the ".concat((0, _pluralize.default)('character', invalidChars.length), " ").concat(invalidChars.join(', ')));
    }
    _.api.get((0, _.getValidatorsUrl)('email', value)).then(function (_ref4) {
      var data = _ref4.data;
      var _data$exists2 = data.exists,
        exists = _data$exists2 === void 0 ? false : _data$exists2,
        result = data.result,
        disposable = data.disposable,
        did_you_mean = data.did_you_mean,
        invalidCharacter = data.invalidCharacter;
      var errText;
      if (existenceValidation && exists) {
        errText = 'Someone already has an account with the same email. Please try another email.';
      } else if (invalidCharacter) {
        errText = 'Email contains invalid characters';
      } else if (result === 'undeliverable' || disposable) {
        if (did_you_mean) {
          errText = "Invalid email. Did you mean ".concat(did_you_mean, "?");
        } else if (disposable) {
          errText = 'Sorry, we don’t accept temporary emails. Please use a permanent email address.';
        } else {
          errText = 'Please enter a valid email address.';
        }
      }
      callback(errText);
    }).catch(function (reason) {
      return console.error('Was not able to validate email', reason);
    });
  }, delay);
  return [{
    required: true,
    message: 'Please enter an email address'
  }, {
    type: 'email',
    message: 'Please enter a valid email address'
  }, {
    validator: emailValidator
  }];
};
exports.getEmailValidators = getEmailValidators;
var getNicknameValidators = function getNicknameValidators() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref5$delay = _ref5.delay,
    delay = _ref5$delay === void 0 ? debounceDelay : _ref5$delay,
    skippedValue = _ref5.skippedValue;
  var nicknameValidator = (0, _lodash.debounce)(function (rule, value, callback) {
    if (!value || !value.trim() || skippedValue && skippedValue === value) {
      return callback();
    }
    var invalidChars = (0, _lodash.uniq)(_toConsumableArray(value.match(_.invalidHttpHeaderCharRegex) || []));
    if (!(0, _lodash.isEmpty)(invalidChars)) {
      return callback("Nickname cannot contain the ".concat((0, _pluralize.default)('character', invalidChars.length), " ").concat(invalidChars.join(', ')));
    }
    _.api.get((0, _.getValidatorsUrl)('nickname', value)).then(function (_ref6) {
      var data = _ref6.data;
      var _data$exists3 = data.exists,
        exists = _data$exists3 === void 0 ? false : _data$exists3,
        invalidCharacter = data.invalidCharacter;
      var errText;
      if (exists) {
        errText = 'Someone is already using the nickname you’ve provided. Please try another nickname.';
      } else if (invalidCharacter) {
        errText = 'Nickname contains invalid characters';
      }
      callback(errText);
    }).catch(function (reason) {
      return console.error('Was not able to validate nickname', reason);
    });
  }, delay);
  return [{
    required: true,
    message: 'Please enter a nickname',
    whitespace: true
  }, {
    pattern: _.nickNameRegex,
    message: 'Nickname can only contain alphanumeric and underscore symbols'
  }, {
    pattern: _.startsWithLetterRegex,
    message: 'Nickname must start with a letter'
  }, {
    min: 3,
    message: 'Nickname must be between 3 and 29 characters long'
  }, {
    max: 29,
    message: 'Nickname must be between 3 and 29 characters long'
  }, {
    validator: nicknameValidator
  }];
};
exports.getNicknameValidators = getNicknameValidators;
var eRxIdValidator = function eRxIdValidator() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : debounceDelay;
  return (0, _lodash.debounce)(function (rule, value, callback) {
    if (!value) {
      callback();
      return;
    }
    _.apiWithoutErrorsHandler.get((0, _.getValidateErxIdrUrl)(value)).then(function () {
      callback();
    }).catch(function () {
      callback("Clinician ".concat(value, " not found"));
    });
  }, delay);
};
exports.eRxIdValidator = eRxIdValidator;
var npiNumberValidator = function npiNumberValidator() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$delay = _ref7.delay,
    delay = _ref7$delay === void 0 ? debounceDelay : _ref7$delay;
  return (0, _lodash.debounce)(function (rule, value, callback) {
    if (!value) {
      callback();
      return;
    }
    _.apiWithoutErrorsHandler.get((0, _.getNpiValidatorsUrl)(value)).then(function () {
      callback();
    }).catch(function () {
      callback('Npi number is not valid');
    });
  }, delay);
};
exports.npiNumberValidator = npiNumberValidator;
var patternValidator = function patternValidator() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref8$delay = _ref8.delay,
    delay = _ref8$delay === void 0 ? debounceDelay : _ref8$delay,
    _ref8$pattern = _ref8.pattern,
    pattern = _ref8$pattern === void 0 ? /.+/ : _ref8$pattern,
    _ref8$message = _ref8.message,
    message = _ref8$message === void 0 ? 'Please enter valid value' : _ref8$message;
  return (0, _lodash.debounce)(function (rule, value, callback) {
    if (!value) {
      callback();
      return;
    }
    var isValid = pattern.test(value);
    callback(isValid ? undefined : message);
  }, delay);
};
exports.patternValidator = patternValidator;
var whitespaceValidator = {
  pattern: _.whiteSpaceRegex,
  message: 'Empty value is not allowed'
};
exports.whitespaceValidator = whitespaceValidator;
var priceValidator = function priceValidator() {
  return patternValidator({
    pattern: _.priceRegex,
    message: 'Please use the format 00.00'
  });
};
exports.priceValidator = priceValidator;
var urlValidator = function urlValidator() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref9$delay = _ref9.delay,
    delay = _ref9$delay === void 0 ? debounceDelay : _ref9$delay,
    _ref9$message = _ref9.message,
    message = _ref9$message === void 0 ? 'Please enter valid URL' : _ref9$message;
  return (0, _lodash.debounce)(function (rule, value, callback) {
    if (!value) {
      callback();
      return;
    }
    var isValid = !(0, _validate.default)({
      link: value
    }, {
      link: {
        url: true
      }
    });
    callback(isValid ? undefined : message);
  }, delay);
};
exports.urlValidator = urlValidator;
var passwordValidator = function passwordValidator(params) {
  var _ref10 = params || {},
    email = _ref10.email,
    nickName = _ref10.nickName;
  var combinedValidator = function combinedValidator(rule, value, callback) {
    var _lowerEmail$split;
    if (!value) {
      callback();
      return;
    }
    var result;
    var lowerNickName = (0, _lodash.toLower)(nickName);
    var lowerEmail = (0, _lodash.toLower)(email);
    var userName = email && ((_lowerEmail$split = lowerEmail.split('@')) === null || _lowerEmail$split === void 0 ? void 0 : _lowerEmail$split.shift());
    if ((value === null || value === void 0 ? void 0 : value.length) < _.PASSWORD_MIN_LENGTH) {
      result = "Password must contain at least ".concat(_.PASSWORD_MIN_LENGTH, " characters");
    } else if (!_.passwordRegex.test(value)) {
      result = 'Passwords must contain at least one lowercase letter, uppercase letter, and number';
    } else if (email && (0, _lodash.toLower)(value).indexOf(lowerEmail) > -1) {
      result = 'Password should not include your email';
    } else if (userName && (0, _lodash.toLower)(value).indexOf(userName) > -1) {
      result = 'Password should not include part of your email';
    } else if (nickName && (0, _lodash.toLower)(value).indexOf(lowerNickName) > -1) {
      result = 'Password cannot include a nickname';
    }
    callback(result);
  };
  return combinedValidator;
};
exports.passwordValidator = passwordValidator;
var copayValidator = function copayValidator(rule, value, callback) {
  if (!value) {
    callback();
    return;
  }
  var pattern = /(^\$(\d{1,})*(\.\d{2})?$)|(^(\d?)*(\.\d+)?%$)/;
  var isValid = pattern.test(value);
  callback(isValid ? undefined : 'Please use the format $00.00 or 00.00%');
};
exports.copayValidator = copayValidator;
var validOrEmptyDateInputValidator = function validOrEmptyDateInputValidator(rule, value, callback) {
  var invalidDateError = 'Please enter a valid date';
  var emptyMask = '__ / __ / ____';
  try {
    if (!value || value === emptyMask) {
      callback();
    }
    var currentDate = (0, _.formatToDateInputMoment)(value);
    if (!currentDate.isValid()) {
      callback(invalidDateError);
      return;
    }
    callback();
  } catch (_unused) {
    callback(invalidDateError);
  }
};
exports.validOrEmptyDateInputValidator = validOrEmptyDateInputValidator;
var validDateAndNotEmptyIfHasInitialValueValidator = function validDateAndNotEmptyIfHasInitialValueValidator(initialValue) {
  var validator = function validator(rule, value, callback) {
    var invalidDateError = 'Please enter a valid date';
    var canNotDeleteExistingDateError = 'Enrollment date was previously populated. Can’t remove it';
    var emptyMask = '__ / __ / ____';
    var isEmptyValue = !value || value === emptyMask;
    try {
      if (isEmptyValue) {
        if (initialValue) {
          callback(canNotDeleteExistingDateError);
        } else {
          callback();
        }
      }
      var currentDate = (0, _.formatToDateInputMoment)(value);
      if (!currentDate.isValid()) {
        callback(invalidDateError);
        return;
      }
      callback();
    } catch (_unused2) {
      callback(invalidDateError);
    }
  };
  return [{
    validator: validator
  }];
};
exports.validDateAndNotEmptyIfHasInitialValueValidator = validDateAndNotEmptyIfHasInitialValueValidator;
var birthDateValidator = function birthDateValidator(rule, value, callback) {
  var tooYoungError = 'You must be 18 or older to sign up for Monument';
  var invalidDateError = 'Please enter a valid date';
  try {
    var today = _momentTimezone.default.utc();
    var birthDate = (0, _.formatToDateInputMoment)(value);
    if (!birthDate.isValid()) {
      callback(invalidDateError);
      return;
    }

    // Result is an integer truncated to zero decimal places
    // A day before the person's 18th birthday, result will be 17
    // On the day of the person's 18th birthday, result will be 18
    var age = today.diff(birthDate, 'years');
    if (age >= 120) {
      callback(invalidDateError);
    } else if (age < 18) {
      callback(tooYoungError);
    } else if (isNaN(age)) {
      callback(invalidDateError);
    } else {
      callback();
    }
  } catch (_unused3) {
    callback(invalidDateError);
  }
};
exports.birthDateValidator = birthDateValidator;
var dollarsCentsValidator = function dollarsCentsValidator(rule, value, callback) {
  var invalidError = 'Dollars.cents';
  var pattern = _.dollarsOptionalCentsRegex;
  try {
    if (!value || value === '0') {
      callback();
    }
    if (!pattern.test(value)) {
      callback(invalidError);
      return;
    }
    callback();
  } catch (_unused4) {
    callback(invalidError);
  }
};
exports.dollarsCentsValidator = dollarsCentsValidator;
var percentValidator = function percentValidator(rule, value, callback) {
  var invalidError = '0 to 100 only';
  try {
    if (!value) {
      callback();
    }
    if (value[0] === '0' && value.length > 1) {
      callback(invalidError);
    }
    var numValue = Number(value);
    if (Number.isInteger(numValue) && numValue >= 0 && numValue <= 100) {
      callback();
    }
    callback(invalidError);
  } catch (_unused5) {
    callback(invalidError);
  }
};
exports.percentValidator = percentValidator;
var imageUploaderImageRequiredValidator = function imageUploaderImageRequiredValidator(rule, value, callback) {
  var isValid = !(0, _lodash.isEmpty)(value);
  callback(isValid ? undefined : rule.message);
};
exports.imageUploaderImageRequiredValidator = imageUploaderImageRequiredValidator;
var getMaxPriceValidator = function getMaxPriceValidator(max) {
  var validator = function validator(rule, value, callback) {
    if (!value) {
      callback();
      return;
    }
    var result;
    if ((0, _.parsePriceFormStringToNum)(value) > max) {
      result = "Price must be less than ".concat(max);
    }
    callback(result);
  };
  return validator;
};
exports.getMaxPriceValidator = getMaxPriceValidator;